<style src="./style.scss">

</style>

{#if items && items.length>0}
<div class="mbsc-col-12">
  <header>
    <h1>{title}</h1>
    <p class="mbsc-col-lg-8">{subtitle}</p>
  </header>
  <div class="mbsc-row">
    {#each items as item }
    <div class="mbsc-col-12 {containerClass} card-info">
      <div class="mbsc-card-header">
        <img src="{item.image}" class="mbsc-avatar" width="34" height="34" alt="related">
        <h5 class="mbsc-card-title mbsc-bold">{item.name}</h5>
        <div class="mbsc-card-subtitle">{item.subtitle}</div>
      </div>
      <img class="mbsc-media-fluid" src="{item.featured ? item.featured : item.image}" alt="related">
      <div class="mbsc-card-content">
        {item.description}
      </div>
      <div class="mbsc-card-footer mbsc-align-right">
        <button class="mbsc-btn-flat" on:click={() => goTo(item) }>{actionLabel}</button>
      </div>
    </div>
    {/each}
  </div>
</div>
{/if}

<script>
  import { onMount, afterUpdate } from 'svelte';
  import { navigateTo } from 'yrv';
  import { Instructor, AWSAuth, Navigation } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  export let title = 'Sesiones Destacados';
  export let subtitle = 'Nuestro equipo de instructores es especialista en cada una de sus disciplinas, te garantizamos la mejor experiencia de aprendizaje y sobre todo diversión en el camino.';
  export let items = Instructor.getAll();
  export let actionLabel = 'Conócelo';
  export let followLink = false;

  let containerClass = items.length >= 3 ? 'mbsc-col-md-4' : (items.length === 1 ? 'mbsc-col-md-12' : 'mbsc-col-md-6');

  import dnsLogo from './../../../public/images/d-ns-panel.jpg';

  let goTo = async (session) => {
    if (followLink) {
      navigateTo(session.slug);
      return;
    }
    const subscription = await AWSAuth.hasValidSubscription();
    if (subscription === true) {
      navigateTo('/session/' +  session.id);
      window.location.reload();
      return;
    }else if (subscription === 'free') {
      if (!session.isFree) {
        mobiscroll.snackbar({
          message: 'Este no es un video gratuito ¿quiéres actualizar tu subscripción?',
          display: 'top',
          color: 'info',
          button: {
            text: '¡Sí!',
            action: function () {
              Navigation.goTo('account');
            }
          }
        });
      }else{
        navigateTo('/session/' +  session.id);
        window.location.reload();
        return;
      }
    }else if (!subscription) {
      if (!session.isFree) {
        mobiscroll.snackbar({
          message: 'Tu subscripción ha caducado, ¿quiéres renovarla ahora?',
          display: 'top',
          color: 'info',
          button: {
            text: '¡Sí!',
            action: function () {
              Navigation.goTo('account');
            }
          }
        });
      }else{
        navigateTo('/session/' +  session.id);
        window.location.reload();
        return;
      }
    }else{
      mobiscroll.snackbar({
        message: 'Registrate ahora y accede a las sesiones gratis todo el tiempo que las necesites.',
        display: 'top',
        color: 'info',
        button: {
          text: '¡Regístrame!',
          action: function () {
            Navigation.goTo('account');
          }
        }
      });
    }
  };

  afterUpdate(() => {
    mobiscroll.card('.card-info', {});
    /*
    if (items.length >= 3) {
      return;
    }
    if (items.length == 1) {
      containerClass = 'mbsc-col-md-12';
    } else if (items.length == 2) {
      containerClass = 'mbsc-col-md-6';
    }
    */
  });

  onMount(async () =>{});
</script>
